import { render, staticRenderFns } from "./ReviewOrderDonut.vue?vue&type=template&id=d7f46754"
import script from "./ReviewOrderDonut.vue?vue&type=script&lang=js"
export * from "./ReviewOrderDonut.vue?vue&type=script&lang=js"
import style0 from "./ReviewOrderDonut.vue?vue&type=style&index=0&id=d7f46754&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports